import axios from "axios";

const instance = axios.create({
  baseURL: "https://internal-api-krjt3.ondigitalocean.app",
});

export default instance;
